import { GitHubAppSection } from '../components/GitHubAppSection';

export function SettingsGitHub() {
  return <GitHubAppSection />;
}
